module.exports = __webpack_public_path__ + "assets/fonts/ProximaNova-Bold.9d3dc8fa.ttf";